/* tslint:disable */
/* eslint-disable */
/**
 * Autom8.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {exists} from '../runtime';

/**
 *
 * @export
 * @interface BooleanApiResult
 */
export interface BooleanApiResult {
    /**
     *
     * @type {boolean}
     * @memberof BooleanApiResult
     */
    success?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof BooleanApiResult
     */
    content?: boolean;
    /**
     *
     * @type {string}
     * @memberof BooleanApiResult
     */
    message?: string | null;
}

export function BooleanApiResultFromJSON(json: any): BooleanApiResult {
    return BooleanApiResultFromJSONTyped(json, false);
}

export function BooleanApiResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): BooleanApiResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'success': !exists(json, 'success') ? undefined : json['success'],
        'content': !exists(json, 'content') ? undefined : json['content'],
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function BooleanApiResultToJSON(value?: BooleanApiResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'success': value.success,
        'content': value.content,
        'message': value.message,
    };
}

